// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"1a27bea8","115":"351d3b27","118":"e5189ddc","204":"5bb8466a","303":"2d47d427","581":"03a03359","634":"ebc75291","963":"ffd9b1ce"}[chunkId] + ".chunk.js";
};